const userMainDataActions = {
  USER_MAIN_DATA_INIT: 'USER_MAIN_DATA_INIT',
  USER_MAIN_DATA_SET: 'USER_MAIN_DATA_SET',
  USER_MAIN_DATA_PROP_SET: 'USER_MAIN_DATA_PROP_SET',
  USER_PERMISSIONS_ADD: 'USER_PERMISSIONS_ADD',
  USER_PERMISSIONS_DELETE: 'USER_PERMISSIONS_DELETE',
  USER_PERMISSION_UPDATE: 'USER_PERMISSION_UPDATE'
};
export default userMainDataActions;
